import React from "react";
import DefaultModal from "../../../modal/DefaultModal";
import { useTranslation } from "react-i18next";
import CusButton from "../../../mui/custom_button/CusButton";
import "./active-fs-bonus.scss";

export default function ActiveBonus({ isOpen, closeModal, bonus, onConfirm }) {
  const { t } = useTranslation();
  return (
    <DefaultModal miniModal isOpen={isOpen} closeModal={closeModal} classModal="active-fs-bonus">
      <h1>{t("Activate bonus")}</h1>

      <p>{t("Activate bonus:", { name: bonus.name || "" })}</p>

      <div className="refuse-bonus__buttons">
        <CusButton text="No" onClick={closeModal} />
        <CusButton text="Activate" onClick={onConfirm} color="green3" />
      </div>
    </DefaultModal>
  );
}
